import React, {Component} from 'react';
import Logger from "../helpers/Logger";
import FareAlert from "./FareAlert";

export default class FareAlertContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in FareAlertContainer', error.toString());
    }

    render() {
        return (<FareAlert translations={this.props.translations} currency={this.props.currency} alertUrl={this.props.alertUrl}/>);
    }
}

export const DOMAIN = 'fareAlert';



// WEBPACK FOOTER //
// ./src/components/FareAlertContainer.js